import useAuth from 'hooks/useAuth';

import Logo from 'components/Logo';
import Spinner from 'components/Spinner';

import AuthApp from 'app/AuthApp';
import MainApp from 'app/MainApp';

import 'app/App.scss';
import {useLayoutEffect, useState} from 'react';
import PaymentForm from 'pages/PaymentForm';
import styles from './Logo.module.scss';
import Tracking from 'pages/Tracking';
import RouteTracking from 'pages/RouteTracking';

function Loading() {
  return (
    <div className="content --full-width --center --column">
      <div className={styles.brand}>
        <div className={styles.logo}>
          <Logo style={{width: 100, height: 100}} />
        </div>
      </div>
      <Spinner />
    </div>
  );
}

function useApp() {
  const {loading, currentUser} = useAuth();
  const [paymentId, setPaymentId] = useState('');
  const [trackId, setTrackId] = useState('');
  const [routeTrackingId, setRouteTrackingId] = useState('');

  useLayoutEffect(() => {
    if (window.location.pathname.endsWith('/payment')) {
      const id = window.location.href.split('id=')[1];
      setPaymentId(id);
    } else if (window.location.pathname.endsWith('/track')) {
      const id = window.location.href.split('id=')[1];
      setTrackId(id);
    } else if (window.location.pathname.endsWith('/route-tracking')) {
      const id = window.location.href.split('id=')[1];
      setRouteTrackingId(id);
    }
  }, []);

  if (paymentId) {
    return <PaymentForm id={paymentId} />;
  }

  if (trackId) {
    return <Tracking id={trackId} />;
  }

  if (routeTrackingId) {
    return <RouteTracking id={routeTrackingId} />;
  }

  if (loading) return <Loading />;

  if (currentUser) {
    return <MainApp />;
  } else {
    return <AuthApp />;
  }
}

function App() {
  const app = useApp();
  return <div className="App">{app}</div>;
}

export default App;
